import * as React from "react";
const Re7Icon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.5 2H8.5V3.46341H10.5V2H13.5V3.46341H15.5V2H18.5V6.87805H5.5V2Z"
      fill="black"
    />
    <path d="M17 10.2927H7V14.1951H17V10.2927Z" fill="black" />
    <path d="M5 17.6098H19V22H5V17.6098Z" fill="black" />
  </svg>
);
export default Re7Icon;
